<div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="24px" fxLayout.lt-md="column" class="layout padding-left padding-right">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.lt-md="start center" fxLayoutGap="8px" >
      <span class="label">Share offer:</span>
      <button mat-mini-fab type="button" color="primary" (click)="sendEmailOffer()">
        <mat-icon>send</mat-icon>
      </button>
      <button mat-mini-fab type="button" color="primary" (click)="copy()" class="">
        <mat-icon>content_copy</mat-icon>
      </button>
      <span class="label">Customer view:</span>
      <button mat-mini-fab type="button" color="primary" (click)="customerView()">
        <mat-icon>visibility</mat-icon>
      </button>
    </div>
</div>
